import React from 'react'
import { Box } from '@mui/material'
import { K1Information } from '@e3dc-react/icons'
import { Typography } from '@e3dc-react/shell/Elements/Typography'

type SettingInfoBoxProps = {
  title?: string
  description: string
  children?: React.ReactNode
}

/**
 * Displays information about the currently selected setting option.
 */
export const SettingInfoBox: React.FC<SettingInfoBoxProps> = ({ title, description, children }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      bgcolor: 'shades.shade04',
      border: '1px solid',
      borderColor: 'shades.shade03',
      borderRadius: 1,
      px: 4,
      py: 2,
    }}
  >
    <Box display="flex" alignItems="center" gap={2}>
      <K1Information fontSize="medium" />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
        <Typography variant="body1">{title}</Typography>
        <Typography variant="body2">{description}</Typography>
      </Box>
    </Box>
    {children}
  </Box>
)
